import React from 'react';

const About = () => {
  return (
    <section id="about" className="py-20 bg-gradient-to-b from-gray-900 to-gray-900">
      <div className="container mx-auto px-6 max-w-4xl">
        <h2 className="text-3xl font-bold mb-8 text-center text-blue-300">About Me</h2>
        <div className="bg-white bg-opacity-10 rounded-2xl shadow-xl p-8 mb-10 hover:shadow-blue-500/30 transition duration-500">
        <p className="text-lg mb-6">
          I’m Suprith, a Computer Science student at PES University with a strong interest in Data and AI. 
          I’m currently interning as an AI/ML Engineer Intern at Netcore Cloud, having previously interned at CID Karnataka and Dover India, working on machine learning systems and data pipelines. I enjoy building AI applications and contributing to open-source projects.
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;